import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcBarChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.91406 23H20.4141C21.9328 23 23.1641 21.7688 23.1641 20.25V3.75C23.1641 2.23122 21.9328 1 20.4141 1H3.91406C2.39528 1 1.16406 2.23122 1.16406 3.75V20.25C1.16406 21.7688 2.39528 23 3.91406 23Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.16406 17L7.16406 13",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1641 17L12.1641 8",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1641 17L17.1641 11",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgIcBarChart;
